import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { MailCheck, MailOpen, MailX, Send } from "lucide-react";
import React from "react";
import { useGetWorkflowsExecutionChannelSummary } from "@features/ux/components/workflow/hooks";
import { useParams } from "react-router-dom";

const EmailDashboard = () => {
  const { id } = useParams();
  const { data: emailSummary } = useGetWorkflowsExecutionChannelSummary(id,"email");
  const statsData = [
    {
      title: "Sent",
      count: emailSummary?.sent,
      icon: <Send className="h-7 w-7 text-gray-600" />,
    },
    {
      title: "Delivered",
      count: emailSummary?.delivered,
      icon: <MailCheck className="h-7 w-7 text-blue-600" />,
    },
    {
      title: "Failed",
      count: emailSummary?.failed,
      icon: <MailX className="h-7 w-7 text-amber-600" />,
    },
    {
      title: "Opened",
      count: emailSummary?.opened,
      icon: <MailOpen className="h-7 w-7 text-green-600" />,
    },
  ];
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {statsData.map((stat, index) => (
        <QuickStatsCard
          key={index}
          title={stat.title}
          count={stat.count}
          icon={stat.icon}
        />
      ))}
    </div>
  );
};

export default EmailDashboard;
